import { render, staticRenderFns } from "./QualityControlEdit.vue?vue&type=template&id=1fe5d196"
import script from "./QualityControlEdit.vue?vue&type=script&lang=js"
export * from "./QualityControlEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports